export enum Gender {
    Other = 0,
    Male = 1,
    Female = 2
}
